import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockMovements } from '@/renderer/services/inventoryStockMovementService';
import type { InventoryStockMovementFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockMovements(
  params: InventoryStockMovementFilterParams,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockMovementsList(params),
    queryFn: async () => {
      const result = await fetchInventoryStockMovements(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock movements',
        );
      }

      return result.data;
    },
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}
